var _defs, _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "successIcon_svg__a",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00B83E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#85C400"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#successIcon_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13.5L10 17l7.5-8 .5-2-2 .5-6 6.5-2-2-2-.5.5 2z",
    fill: "#fff"
  })));
}

export default SvgSuccessIcon;